import { IEvent } from "modules/event/types";

export const resetTextAndMediaDefault = (event: IEvent) => ({
  ...event,
  isTextDefault: false,
  isMediaDefault: false,
});
